import throttle from 'raf-throttle';
import { $$ } from '../lib/domUtils';

const carousels = $$('.js-carousel');

// Shares the lazily-loaded Glide chunk with banner.js -- see the note there.
if (carousels.length) {
  import('@glidejs/glide').then(({ default: Glide }) => {
    carousels.forEach(element => {
      const perRow = element.getAttribute('data-per-row');
      const loop = !(element.getAttribute('data-loop') === 'false');
      const breakpoint = element.getAttribute('data-breakpoint');

      const glide = new Glide(element, {
        type: loop ? 'carousel' : 'slider',
        gap: 48,
        perView: perRow,
        bound: !loop,
        autoplay: loop ? 4000 : false,
        animationDuration: 800,
        animationTimingFunc: 'cubic-bezier(0.13, -0.01, 0.16, 1)',
        breakpoints: {
          649: {
            perView: 1,
          },
        },
      });

      function testBreakpoint() {
        if (window.matchMedia(breakpoint).matches) {
          element.classList.remove('c-carousel--disabled');
          glide.mount();
        } else {
          glide.destroy();
          element.classList.add('c-carousel--disabled');
        }
      }

      if (breakpoint) {
        window.addEventListener(`resize`, throttle(testBreakpoint), { passive: true });
        testBreakpoint();
      } else {
        glide.mount();
      }
    });
  });
}
